import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect } from "react";
import { useState } from "react";
import { FormDropDown } from "../../components/form/dropdown";
import { api } from "../../redux/apis/api";

const CreateCity = () => {
  const naviagte = useNavigate();
  const [stateList, setstateList] = useState([]);

  const initialValues = {
    state_id: "",
    name: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/settings/city/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/city/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                city - Create
              </h2>
              <div className="flex gap-3 items-center">
                <button
                  onClick={() => naviagte("/city/list")}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Create
                </button>
              </div>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormDropDown
                  name="state_id"
                  label="state"
                  options={stateList}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"name"}
                  label={"name"}
                  placeholder={`Enter state name`}
                />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateCity;
